import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-open-quotes',
    templateUrl: './open-quotes.component.html',
    styleUrls: ['./open-quotes.component.scss']
})
export class OpenQuotesComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.openQuotes;
    chartSearchFilters: widgetFilters[] = [
        widgetFilters.customer,
        widgetFilters.class,
        widgetFilters.svcConst,
        widgetFilters.state,
        widgetFilters.priority,
        widgetFilters.quoteStatus,
        widgetFilters.onCallRegion,
        widgetFilters.divisions
    ];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
